import { render } from "./AudienceOverview.vue?vue&type=template&id=487064a1"
import script from "./AudienceOverview.vue?vue&type=script&lang=js"
export * from "./AudienceOverview.vue?vue&type=script&lang=js"

import "./AudienceOverview.vue?vue&type=style&index=0&id=487064a1&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__